import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { APP_CONFIG } from '@cfg/env/app.config';
import { ResultTypeRepository } from '@service/templates/result-type.repository';
import { ResultType } from '@model/templates';

const handleError = (err: unknown) =>
  throwError(() => new Error((err as { error?: { message?: string }; message?: string })?.error?.message ?? (err as Error)?.message ?? 'Error desconocido'));

@Injectable({ providedIn: 'root' })
export class HttpResultTypeRepository extends ResultTypeRepository {
  private readonly httpClient = inject(HttpClient);
  private readonly appConfig = inject(APP_CONFIG);

  private get baseUrl(): string {
    const config = this.appConfig.validationResults as
      | { baseUrl?: string; context: string }
      | undefined;
    const base = config?.baseUrl ?? '';
    const context = config?.context ?? '/validacion_resultados';
    return `${base}${context}`;
  }

  override findAll(): Observable<ResultType[]> {
    return this.httpClient.get<ResultType[]>(`${this.baseUrl}/result-types`).pipe(catchError(handleError));
  }

  override create(resultType: Partial<ResultType>): Observable<ResultType> {
    return this.httpClient.post<ResultType>(`${this.baseUrl}/result-types`, resultType).pipe(catchError(handleError));
  }

  override update(id: string, resultType: Partial<ResultType>): Observable<ResultType> {
    return this.httpClient.put<ResultType>(`${this.baseUrl}/result-types/${id}`, resultType).pipe(catchError(handleError));
  }

  override deactivate(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.baseUrl}/result-types/${id}`).pipe(catchError(handleError));
  }
}
